import { FC } from "react";
import { useTranslation } from "react-i18next";
import { MobileSearch } from "src/Modules/Flights/Components";

interface JourneySearchMobProps {
  imgUrl?: string;
}

const JourneySearchMob: FC<JourneySearchMobProps> = ({ imgUrl }) => {
  const { t } = useTranslation();
  return (
    <div className="flex w-full flex-col items-center justify-center pb-2">
      <div className="relative w-full">
        <div
          className="relative h-[260px] w-full overflow-hidden bg-cover shadow-inner"
          style={{ backgroundImage: `url(${imgUrl})`}}
        >
          <div className="absolute inset-0 bg-background-overlay/35" />
          <div className="relative z-10 flex h-full flex-col justify-center gap-1.5 px-5 pb-16">
            <h1 className="text-start text-xl font-bold leading-tight text-font-inverted drop-shadow-sm">
              {t("Flights.search.heroTitle")}
            </h1>
            <p className="text-start text-sm text-font-inverted drop-shadow-sm">{t("Flights.search.heroSubtitle")}</p>
          </div>
        </div>

        <div className="relative z-20 -mt-20 h-full bg-background-default rounded-2xl">
          <MobileSearch />
        </div>
      </div>
    </div>
  );
};

export default JourneySearchMob;

